// client/src/services/driverService.ts

import { apiClient, PaginatedResponse } from './api';

export interface Driver {
  id: string;
  tenant_id: string;
  user_id: string;
  license_number: string;
  license_expiry: string;
  hire_date: string;
  termination_date?: string;
  is_active: boolean;
  notes?: string;
  created_at: string;
  updated_at: string;
  // User fields from JOIN
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
}

export interface CreateDriverData {
  user_id: string;
  license_number: string;
  license_expiry: string;
  hire_date: string;
  notes?: string;
}

export interface UpdateDriverData {
  license_number?: string;
  license_expiry?: string;
  hire_date?: string;
  termination_date?: string;
  is_active?: boolean;
  notes?: string;
}

export class DriverService {
  private readonly baseUrl = '/admin/drivers';

  async getDrivers(filters?: {
    is_active?: boolean;
    search?: string;
    limit?: number;
    offset?: number;
  }): Promise<PaginatedResponse<Driver>> {
    const params: Record<string, string> = {};
    if (filters?.is_active !== undefined) params.is_active = filters.is_active.toString();
    if (filters?.search) params.search = filters.search;
    if (filters?.limit) params.limit = filters.limit.toString();
    if (filters?.offset) params.offset = filters.offset.toString();

    const url = apiClient.buildUrl(this.baseUrl, params);
    return apiClient.get<PaginatedResponse<Driver>>(url);
  }

  async getDriverById(id: string): Promise<Driver> {
    return apiClient.get<Driver>(`${this.baseUrl}/${id}`);
  }

  async createDriver(data: CreateDriverData): Promise<Driver> {
    return apiClient.post<Driver>(this.baseUrl, data);
  }

  async updateDriver(id: string, data: UpdateDriverData): Promise<Driver> {
    return apiClient.put<Driver>(`${this.baseUrl}/${id}`, data);
  }

  async deleteDriver(id: string): Promise<void> {
    return apiClient.delete(`${this.baseUrl}/${id}`);
  }
}

export const driverService = new DriverService();
